import { render, staticRenderFns } from "./AppStatusBadge.vue?vue&type=template&id=5902357c&scoped=true"
import script from "./AppStatusBadge.vue?vue&type=script&lang=js"
export * from "./AppStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./AppStatusBadge.vue?vue&type=style&index=0&id=5902357c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5902357c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5902357c')) {
      api.createRecord('5902357c', component.options)
    } else {
      api.reload('5902357c', component.options)
    }
    module.hot.accept("./AppStatusBadge.vue?vue&type=template&id=5902357c&scoped=true", function () {
      api.rerender('5902357c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/External/Shoplazza/components/AppStatusBadge.vue"
export default component.exports